import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';

import { SimpleLoadingComponent, loadMorePaginationProp } from '../../utils/apollo';
import RepVisitsNotificationsActivityComponent from './notifications-activity';
import { defaultNotificationTypes } from '../../components/ActivityNotification/constants';

const actorFragment = gql`
  fragment ActorDetails on CommunityPerson {
    id
    name
    uuid
    field_profile_picture_file_url
    field_user_institution_title
    institutionId
    field_office_phone
    field_office_phone_privacy
    field_mobile_phone
    field_mobile_phone_privacy
    field_job_position
    field_contact_work
  }
`;

const query = gql`
  query RepVisitsNotifications($first: Int!, $after: String, $notificationTypes: [RepVisitsNotificationType]) {
    viewer {
      id
      uuid
      repVisitsNotifications(first: $first, after: $after, notificationTypes: $notificationTypes) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            notificationType
            canceledRsvpChosenVisitLocationType
            actor {
              ...ActorDetails
            }
            date
            event {
              id
              date
              name
              startTime
              endTime
              collegeFairId
              appointmentId
              dayId
              chosenVisitLocationType
            }
            rescheduleInfo {
              date
              startTime
              endTime
            }
            message
            highSchool {
              id
              title
              address {
                field_hs_elna_city
                field_hs_elna_state_latest
              }
            }
            reassignInfo {
              fromContact {
                ...ActorDetails
              }
              toContact {
                ...ActorDetails
              }
              }
            }
          }
        }
      }
  }
  ${actorFragment}
`;

const graphqlData = graphql(query, {
  options: {
    variables: {
      first: 25,
      notificationTypes: defaultNotificationTypes,
    },
    fetchPolicy: 'network-only',
  },
  props: loadMorePaginationProp(query),
});

export default SimpleLoadingComponent(graphqlData)(RepVisitsNotificationsActivityComponent);
